import { twMerge } from 'tailwind-merge'

type ClassValue = string | number | boolean | undefined | null | ClassValue[]

export const cn = (...inputs: ClassValue[]): string => {
    const classes = inputs
        .flat()
        .filter((x): x is string | number => typeof x === 'string' || typeof x === 'number')
        .join(' ')
    return twMerge(classes)
}
